import { activeColor, grayColor, pendingColor, primaryColor } from 'assets/jss/material-dashboard-pro-react';

const additionalBenefits = (theme) => ({
	cardWrapper: {
		'min-width': '100%',
		'min-height': '80vh',
		padding: '2rem',
	},
	serviceComponentWrapper: {
		display: 'flex',
		'flex-direction': 'column',
		'align-items': 'flex-start',
	},
	selectAllWrapper: {
		display: 'flex',
		marginBottom: '10px',
	},
	serviceWrapper: {
		display: 'flex',
		background: grayColor[0],
		justifyContent: 'space-between',
		paddingRight: '20px;',
		'align-items': 'center',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
		},
	},
	service: {
		display: 'flex',
		padding: '12px 0 12px 0px',
		'justify-content': 'space-between',
		'align-self': 'stretch',
	},
	checkbox: {
		'margin-right': '.2rem',
	},
	serviceName: {
		fontFamily: theme.fontFamily.albert.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.16px',
		fontSize: theme.fontSize(14),
		lineHeight: theme.fontSize(18),
		color: 'black',
	},
	divider: {
		width: '100%',
		margin: '16px 0 16px 0',
	},
	active: {
		marginLeft: '2rem',
		background: activeColor,
		'font-weight': 'bold',
		borderRadius: '4px',
		width: 'auto',
		[theme.breakpoints.down('sm')]: {
			width: '20%',
		},
	},
	pending: {
		marginLeft: '2rem',
		background: pendingColor,
		'font-weight': 'bold',
		borderRadius: '4px',
		width: 'auto',
	},
	infoClause: {
		'& div': {
			marginTop: '0px',
		},
		marginBottom: '1rem',
	},
	serviceHeading: {
		marginBottom: '24px',
	},
	serviceDescription: {
		marginBottom: '24px',
	},
	disabledCheckbox: {
		'margin-right': '.2rem',
		color: 'rgba(0, 0, 0, 0.26) !important',
	},
	singleServiceWrapper: {
		width: '100%',
		border: `1px solid ${grayColor[0]}`,
		borderRadius: '5px',
		marginBottom: '15px',
	},
	externalLinks: {
		display: 'flex',
		justifyContent: 'flex-end',
		paddingRight: '15px',
		borderTop: `1px solid ${grayColor[0]}`,
		paddingTop: '5px',
	},
	viewTutorial: {
		background: 'transparent',
		color: primaryColor[0],
		border: `1px solid ${primaryColor[0]}`,
		marginRight: '10px',
		textWrap: 'balance',
	},
	alignBetween: {
		justifyContent: 'space-between !important',
	},
	disabledServices: {
		opacity: '0.6',
		cursor: 'pointer',
	},
});

export default additionalBenefits;
